function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

import _find from 'lodash/find';
import _isEqual from 'lodash/isEqual';
import _isFunction from 'lodash/isFunction';
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { constructCosmosApiDataDownloadUrl } from 'js/helpers/apiData';
import CosmosDateRange from 'js/components/legacy/CosmosDateRange';
import { mapPlotMetadataToDataUrl } from '../../containers/legacy/GraphSection';
import DownloadMenuBody from '../../containers/legacy/DownloadMenuBody';

var GraphDownloadButton =
/*#__PURE__*/
function (_React$Component) {
  _inherits(GraphDownloadButton, _React$Component);

  function GraphDownloadButton(props) {
    var _this;

    _classCallCheck(this, GraphDownloadButton);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GraphDownloadButton).call(this, props));
    _this.state = props.plotDateRange || props.plotDateRangeTotal ? _this.convertPropsAndStateToDateObject(props, {}) : {};
    _this._launchDownloadMenuModal = _this._launchDownloadMenuModal.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this._initialVisibleEndMonth = _this._initialVisibleEndMonth.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this._initialVisibleStartMonth = _this._initialVisibleStartMonth.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this._isDateOutsideOfPossibleRange = _this._isDateOutsideOfPossibleRange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this._updateDownloadStartAndEndDate = _this._updateDownloadStartAndEndDate.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(GraphDownloadButton, [{
    key: "_launchDownloadMenuModal",
    value: function _launchDownloadMenuModal() {
      this.props.launchDownloadModal(this.props.plotCountryCode, this.props.plotId, {
        content: {
          body: React.createElement(DownloadMenuBody, {
            plotMetadata: this.props.plotMetadata,
            downloadDataUrl: constructCosmosApiDataDownloadUrl(mapPlotMetadataToDataUrl(this.props.plotMetadata, this.props.plotCountryCode), this.props.plotDateRangeTotal && this.convertStateToPlotDateRange(), this.props.plotSelectedSampleRate)
          })
        }
      });
    }
  }, {
    key: "_initialVisibleEndMonth",
    value: function _initialVisibleEndMonth() {
      return this.state.endDate;
    }
  }, {
    key: "_initialVisibleStartMonth",
    value: function _initialVisibleStartMonth() {
      return this.state.startDate;
    }
  }, {
    key: "_isDateOutsideOfPossibleRange",
    value: function _isDateOutsideOfPossibleRange(momentDate) {
      return !this.props.plotDateRangeTotal || momentDate.isBefore(this.props.plotDateRangeTotal[0], 'day') || momentDate.isAfter(this.props.plotDateRangeTotal[1], 'day');
    }
  }, {
    key: "_updateDownloadStartAndEndDate",
    value: function _updateDownloadStartAndEndDate(stateObject) {
      var _this2 = this;

      this.setState(stateObject, function () {
        if (_isFunction(_this2.props.plotDateRangeUpdate)) {
          _this2.props.plotDateRangeUpdate(_this2.convertStateToPlotDateRange());
        }
      });
    }
  }, {
    key: "convertPropsAndStateToDateObject",
    value: function convertPropsAndStateToDateObject() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      return {
        startDate: props.plotDateRange ? moment(props.plotDateRange[0]) : state.startDate || moment(props.plotDateRangeTotal[0]),
        endDate: props.plotDateRange ? moment(props.plotDateRange[1]) : state.endDate || moment(props.plotDateRangeTotal[1])
      };
    }
  }, {
    key: "convertStateToPlotDateRange",
    value: function convertStateToPlotDateRange() {
      return [this.state.startDate.toDate(), this.state.endDate.toDate()];
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(newProps) {
      if (!_isEqual(newProps.plotDateRange, this.props.plotDateRange) || !this.state.startDate || !this.state.endDate || !_isEqual(newProps.plotDateRange || newProps.plotDateRangeTotal, this.convertStateToPlotDateRange())) {
        this.setState(this.convertPropsAndStateToDateObject(newProps));
      }
    }
  }, {
    key: "downloadDataPanelClasses",
    value: function downloadDataPanelClasses() {
      var classes = ['panel panel-default clearfix data-page__section__download-data-panel'];
      if (this.props.plotDateRangeTotal) classes.push('data-page__section__download-data-panel--with-date');
      return classes.join(' ');
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("div", {
        className: "col-xs-12"
      }, React.createElement("div", {
        className: this.downloadDataPanelClasses()
      }, React.createElement("div", {
        className: "panel-body"
      }, this.props.plotDateRangeTotal ? React.createElement("div", {
        className: "feedback-download-date-range-wrapper"
      }, React.createElement("div", {
        className: "feedback-download-date-range__label"
      }, this.props.downloadDateRangeLabel), React.createElement(CosmosDateRange, {
        plotId: this.props.plotId,
        startDate: this.state.startDate,
        endDate: this.state.endDate,
        isMobileWidth: this.props.isMobileWidth,
        onDatesChange: this._updateDownloadStartAndEndDate,
        isOutsideRange: this._isDateOutsideOfPossibleRange,
        initialVisibleStartMonth: this._initialVisibleStartMonth,
        initialVisibleEndMonth: this._initialVisibleEndMonth
      }), this.props.possibleSampleRates && this.props.possibleSampleRates.length && this.props.plotSelectedSampleRate ? React.createElement("div", {
        className: "feedback-download-date-range__sample-rate-label"
      }, "(", _find(this.props.possibleSampleRates, {
        abbreviation: this.props.plotSelectedSampleRate
      }).title, ")") : null) : null)));
    }
  }]);

  return GraphDownloadButton;
}(React.Component);

GraphDownloadButton.propTypes = {
  plotId: PropTypes.string.isRequired,
  plotCountryCode: PropTypes.string.isRequired,
  plotMetadata: PropTypes.object.isRequired,
  plotDateRange: PropTypes.array,
  plotDateRangeTotal: PropTypes.array,
  plotSelectedSampleRate: PropTypes.string,
  possibleSampleRates: PropTypes.array,
  plotDownloadText: PropTypes.string.isRequired,
  downloadDateRangeLabel: PropTypes.string.isRequired,
  plotDateRangeUpdate: PropTypes.func,
  launchDownloadModal: PropTypes.func.isRequired,
  isMobileWidth: PropTypes.bool.isRequired
};
export { GraphDownloadButton as default };